import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=2b375e47&"
import script from "./Settings.ts?vue&type=script&lang=js&"
export * from "./Settings.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports